/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WebApiIntegrationsDtoCreateFortnoxInvoiceDto
 */
export interface WebApiIntegrationsDtoCreateFortnoxInvoiceDto {
    /**
     * 
     * @type {string}
     * @memberof WebApiIntegrationsDtoCreateFortnoxInvoiceDto
     */
    description?: string | null;
    /**
     * 
     * @type {number}
     * @memberof WebApiIntegrationsDtoCreateFortnoxInvoiceDto
     */
    memberId?: number;
    /**
     * 
     * @type {number}
     * @memberof WebApiIntegrationsDtoCreateFortnoxInvoiceDto
     */
    amount?: number;
    /**
     * 
     * @type {string}
     * @memberof WebApiIntegrationsDtoCreateFortnoxInvoiceDto
     */
    connectedYear?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiIntegrationsDtoCreateFortnoxInvoiceDto
     */
    printTemplate?: string | null;
}

/**
 * Check if a given object implements the WebApiIntegrationsDtoCreateFortnoxInvoiceDto interface.
 */
export function instanceOfWebApiIntegrationsDtoCreateFortnoxInvoiceDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiIntegrationsDtoCreateFortnoxInvoiceDtoFromJSON(json: any): WebApiIntegrationsDtoCreateFortnoxInvoiceDto {
    return WebApiIntegrationsDtoCreateFortnoxInvoiceDtoFromJSONTyped(json, false);
}

export function WebApiIntegrationsDtoCreateFortnoxInvoiceDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiIntegrationsDtoCreateFortnoxInvoiceDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'description': !exists(json, 'description') ? undefined : json['description'],
        'memberId': !exists(json, 'memberId') ? undefined : json['memberId'],
        'amount': !exists(json, 'amount') ? undefined : json['amount'],
        'connectedYear': !exists(json, 'connectedYear') ? undefined : json['connectedYear'],
        'printTemplate': !exists(json, 'printTemplate') ? undefined : json['printTemplate'],
    };
}

export function WebApiIntegrationsDtoCreateFortnoxInvoiceDtoToJSON(value?: WebApiIntegrationsDtoCreateFortnoxInvoiceDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'description': value.description,
        'memberId': value.memberId,
        'amount': value.amount,
        'connectedYear': value.connectedYear,
        'printTemplate': value.printTemplate,
    };
}

